module.exports = __webpack_public_path__ + "img/6.f5e55309.png";